export default __webpack_public_path__ + "static/media/trr-food-pastry-5.7fc274a6.png";